import { defaultQueueMetricsParams } from '@/utils/metricsParams';
import { MetricsSection } from './MetricsSection';
import { api } from '@/store/api';
import { ADHERENCE_GROUPINGS } from '@/types/agentEvents';

const { useGetContactsHandledMetricsQuery } = api;

export function ContactsHandledSection() {
  return (
    <MetricsSection
      titleKey="components.dashboard.contactsHandled"
      descriptionKey="components.dashboard.contactsHandledDescription"
      metricName="contacts-handled"
      defaultParams={defaultQueueMetricsParams()}
      useQuery={useGetContactsHandledMetricsQuery}
      groupingsOptions={ADHERENCE_GROUPINGS}
      refreshLabelKey="components.dashboard.refreshContactsHandled"
    />
  );
}
